export default {
  count: 14,
  next: null,
  previous: null,
  results: [
    {
      id: 1,
      name: "PC",
      slug: "pc",
      platforms: [
        {
          id: 4,
          name: "PC",
          slug: "pc",
          games_count: 540846,
          image_background:
            "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 2,
      name: "PlayStation",
      slug: "playstation",
      platforms: [
        {
          id: 187,
          name: "PlayStation 5",
          slug: "playstation5",
          games_count: 828,
          image_background:
            "https://media.rawg.io/media/games/559/559bc0768f656ad0c63c54b80a82d680.jpg",
          image: null,
          year_start: 2020,
          year_end: null,
        },
        {
          id: 18,
          name: "PlayStation 4",
          slug: "playstation4",
          games_count: 6598,
          image_background:
            "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 16,
          name: "PlayStation 3",
          slug: "playstation3",
          games_count: 3257,
          image_background:
            "https://media.rawg.io/media/games/bc0/bc06a29ceac58652b684deefe7d56099.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 15,
          name: "PlayStation 2",
          slug: "playstation2",
          games_count: 1975,
          image_background:
            "https://media.rawg.io/media/games/13a/13a528ac9cf48bbb6be5d35fe029336d.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 27,
          name: "PlayStation",
          slug: "playstation1",
          games_count: 1617,
          image_background:
            "https://media.rawg.io/media/games/826/82626e2d7ee7d96656fb9838c2ef7302.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 19,
          name: "PS Vita",
          slug: "ps-vita",
          games_count: 1570,
          image_background:
            "https://media.rawg.io/media/games/c47/c4796c4c49e7e06ad328e07aa8944cdd.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 17,
          name: "PSP",
          slug: "psp",
          games_count: 1381,
          image_background:
            "https://media.rawg.io/media/games/dd7/dd72d8a527cd9245c7eb7cd05aa53efa.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 3,
      name: "Xbox",
      slug: "xbox",
      platforms: [
        {
          id: 1,
          name: "Xbox One",
          slug: "xbox-one",
          games_count: 5490,
          image_background:
            "https://media.rawg.io/media/games/562/562553814dd54e001a541e4ee83a591c.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 186,
          name: "Xbox Series S/X",
          slug: "xbox-series-x",
          games_count: 733,
          image_background:
            "https://media.rawg.io/media/games/d47/d479582ed0a46496ad34f65c7099d7e5.jpg",
          image: null,
          year_start: 2020,
          year_end: null,
        },
        {
          id: 14,
          name: "Xbox 360",
          slug: "xbox360",
          games_count: 2777,
          image_background:
            "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 80,
          name: "Xbox",
          slug: "xbox-old",
          games_count: 722,
          image_background:
            "https://media.rawg.io/media/games/bc7/bc77b1eb8e35df2d90b952bac5342c75.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 4,
      name: "iOS",
      slug: "ios",
      platforms: [
        {
          id: 3,
          name: "iOS",
          slug: "ios",
          games_count: 76566,
          image_background:
            "https://media.rawg.io/media/games/d4b/d4bcd78873edd9992d93aff9cc8db0c8.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 8,
      name: "Android",
      slug: "android",
      platforms: [
        {
          id: 21,
          name: "Android",
          slug: "android",
          games_count: 55432,
          image_background:
            "https://media.rawg.io/media/games/6e0/6e0c19bb111bd4fa20cf0eb72a049519.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 5,
      name: "Apple Macintosh",
      slug: "mac",
      platforms: [
        {
          id: 5,
          name: "macOS",
          slug: "macos",
          games_count: 107094,
          image_background:
            "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 55,
          name: "Classic Macintosh",
          slug: "macintosh",
          games_count: 676,
          image_background:
            "https://media.rawg.io/media/games/104/104e82a52297cc7ddd3b05b7e68be04f.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 41,
          name: "Apple II",
          slug: "apple-ii",
          games_count: 422,
          image_background:
            "https://media.rawg.io/media/screenshots/53d/53d57cbd135807d5b9945b3076bd2c9a.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 6,
      name: "Linux",
      slug: "linux",
      platforms: [
        {
          id: 6,
          name: "Linux",
          slug: "linux",
          games_count: 79725,
          image_background:
            "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 7,
      name: "Nintendo",
      slug: "nintendo",
      platforms: [
        {
          id: 7,
          name: "Nintendo Switch",
          slug: "nintendo-switch",
          games_count: 5205,
          image_background:
            "https://media.rawg.io/media/games/be0/be01c3d7d8795a45615da139322ca080.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 8,
          name: "Nintendo 3DS",
          slug: "nintendo-3ds",
          games_count: 1724,
          image_background:
            "https://media.rawg.io/media/games/be5/be51faf9bec778b4ea1b06e9b084792c.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 9,
          name: "Nintendo DS",
          slug: "nintendo-ds",
          games_count: 2474,
          image_background:
            "https://media.rawg.io/media/games/fc0/fc076b974197660a582abd34ebccc27f.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 13,
          name: "Nintendo DSi",
          slug: "nintendo-dsi",
          games_count: 37,
          image_background:
            "https://media.rawg.io/media/screenshots/b45/b452e9b20e969a64d0088ae467d1dcab.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 10,
          name: "Wii U",
          slug: "wii-u",
          games_count: 1201,
          image_background:
            "https://media.rawg.io/media/games/b5a/b5a1226bfd971284a735a4a0969086b3.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 11,
          name: "Wii",
          slug: "wii",
          games_count: 2271,
          image_background:
            "https://media.rawg.io/media/games/dd7/dd72d8a527cd9245c7eb7cd05aa53efa.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 105,
          name: "GameCube",
          slug: "gamecube",
          games_count: 641,
          image_background:
            "https://media.rawg.io/media/screenshots/002/002c8c5f9eb52d936bbc02f4c943a8c0.jpeg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 83,
          name: "Nintendo 64",
          slug: "nintendo-64",
          games_count: 363,
          image_background:
            "https://media.rawg.io/media/screenshots/6ca/6ca508f924da59e8cab1610b30117b56.jpeg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 24,
          name: "Game Boy Advance",
          slug: "game-boy-advance",
          games_count: 957,
          image_background:
            "https://media.rawg.io/media/games/3c8/3c872330c4e9966a5a06c1371525e760.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 43,
          name: "Game Boy Color",
          slug: "game-boy-color",
          games_count: 412,
          image_background:
            "https://media.rawg.io/media/screenshots/a51/a519f93600f1427375260522f47e2e7b.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 26,
          name: "Game Boy",
          slug: "game-boy",
          games_count: 604,
          image_background:
            "https://media.rawg.io/media/games/e40/e4043e92866d08ec9fdd212dcd3a1224.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 79,
          name: "SNES",
          slug: "snes",
          games_count: 944,
          image_background:
            "https://media.rawg.io/media/games/bb1/bb182c89b9d4e19b41e5d0f81caa0f42.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 49,
          name: "NES",
          slug: "nes",
          games_count: 969,
          image_background:
            "https://media.rawg.io/media/games/a75/a75e4cb9742bb172d6bd3deb4cc4109e.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 9,
      name: "Atari",
      slug: "atari",
      platforms: [
        {
          id: 28,
          name: "Atari 7800",
          slug: "atari-7800",
          games_count: 64,
          image_background:
            "https://media.rawg.io/media/screenshots/565/56504b28b184dbc630a7de118e39d822.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 31,
          name: "Atari 5200",
          slug: "atari-5200",
          games_count: 64,
          image_background:
            "https://media.rawg.io/media/screenshots/61a/61a60e3ee55941387681eaa59e3becbf.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 23,
          name: "Atari 2600",
          slug: "atari-2600",
          games_count: 286,
          image_background:
            "https://media.rawg.io/media/screenshots/b12/b12ed274eed80e4aced37badf228d1cf.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 22,
          name: "Atari Flashback",
          slug: "atari-flashback",
          games_count: 30,
          image_background:
            "https://media.rawg.io/media/screenshots/2aa/2aa07f58491e14b0183333f8956bc802.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 25,
          name: "Atari 8-bit",
          slug: "atari-8-bit",
          games_count: 306,
          image_background:
            "https://media.rawg.io/media/games/876/8764efc52fba503a00af64a2cd51f66c.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 34,
          name: "Atari ST",
          slug: "atari-st",
          games_count: 834,
          image_background:
            "https://media.rawg.io/media/screenshots/8dd/8dd23d8d30d988035a06a8f8c462f135.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 46,
          name: "Atari Lynx",
          slug: "atari-lynx",
          games_count: 56,
          image_background:
            "https://media.rawg.io/media/screenshots/575/575b2838392ed177dd7d2c734c682f93.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 50,
          name: "Atari XEGS",
          slug: "atari-xegs",
          games_count: 22,
          image_background:
            "https://media.rawg.io/media/screenshots/769/7691726d70c23c029903df08858df001.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 112,
          name: "Jaguar",
          slug: "jaguar",
          games_count: 37,
          image_background:
            "https://media.rawg.io/media/games/855/8552687245f888ba388bc6ec0dcc3947.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 10,
      name: "Commodore / Amiga",
      slug: "commodore-amiga",
      platforms: [
        {
          id: 166,
          name: "Commodore / Amiga",
          slug: "commodore-amiga",
          games_count: 2075,
          image_background:
            "https://media.rawg.io/media/screenshots/f6b/f6b3338889ec877c9d3d89fc4f665152.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 11,
      name: "SEGA",
      slug: "sega",
      platforms: [
        {
          id: 167,
          name: "Genesis",
          slug: "genesis",
          games_count: 824,
          image_background:
            "https://media.rawg.io/media/games/373/373a9a1f664de6e4c31f08644729e2db.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 107,
          name: "SEGA Saturn",
          slug: "sega-saturn",
          games_count: 347,
          image_background:
            "https://media.rawg.io/media/games/7ca/7ca0df41799243443a4e3887720fdf2a.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 119,
          name: "SEGA CD",
          slug: "sega-cd",
          games_count: 161,
          image_background:
            "https://media.rawg.io/media/screenshots/b45/b452e9b20e969a64d0088ae467d1dcab.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 117,
          name: "SEGA 32X",
          slug: "sega-32x",
          games_count: 47,
          image_background:
            "https://media.rawg.io/media/games/0df/0dfe8852fa43d58cbdeb973765a9828d.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 74,
          name: "SEGA Master System",
          slug: "sega-master-system",
          games_count: 224,
          image_background:
            "https://media.rawg.io/media/screenshots/0e3/0e3fd5a5436b82095044e5a5f8a20d51.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 106,
          name: "Dreamcast",
          slug: "dreamcast",
          games_count: 353,
          image_background:
            "https://media.rawg.io/media/games/96a/96a48ac7487d9db9179d83170afcb16a.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
        {
          id: 77,
          name: "Game Gear",
          slug: "game-gear",
          games_count: 217,
          image_background:
            "https://media.rawg.io/media/games/2c3/2c3363eb1ae202b9e4e7520d3f14ab2e.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 12,
      name: "3DO",
      slug: "3do",
      platforms: [
        {
          id: 111,
          name: "3DO",
          slug: "3do",
          games_count: 95,
          image_background:
            "https://media.rawg.io/media/screenshots/180/180b5f6e5d8c770bbbf941b9875046b6.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 13,
      name: "Neo Geo",
      slug: "neo-geo",
      platforms: [
        {
          id: 12,
          name: "Neo Geo",
          slug: "neogeo",
          games_count: 115,
          image_background:
            "https://media.rawg.io/media/games/5c9/5c9d21b8de81ec72c1717a52d2951319.jpg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
    {
      id: 14,
      name: "Web",
      slug: "web",
      platforms: [
        {
          id: 171,
          name: "Web",
          slug: "web",
          games_count: 273085,
          image_background:
            "https://media.rawg.io/media/screenshots/6aa/6aa8cfccfa7f8d7acbe1a6e24dfb45dd.jpeg",
          image: null,
          year_start: null,
          year_end: null,
        },
      ],
    },
  ],
};
